import { Component, OnInit } from '@angular/core';

import { UINotification } from '../../models/ui-notification.model';
import { UINotificationService } from '../../services/ui-notification.service';

@Component({
  selector: 'app-ui-notification',
  templateUrl: './ui-notification.component.html',
  styleUrls: ['./ui-notification.component.css']
})
export class UINotificationComponent implements OnInit {
  notifications: UINotification[] = [];
  timeoutHandler: any = null;

  constructor(
    private uiNotificationService: UINotificationService
  ) { }

  ngOnInit() {
    this.uiNotificationService.message$.subscribe((message: UINotification) => {
      this.notifications.push(message);
      setTimeout(() => {
        this.removeMessage(message);
      }, 2*1000);
    });
  }

  removeMessage(message: UINotification) {
    const index = this.notifications.indexOf(message);
    if (index == -1) {
      return;
    }
    this.notifications.splice(index, 1);
  }
}
